(() => {
  function initialize(root = document) {
    root.querySelectorAll('.ip-header').forEach(header => {
      if (header.dataset.navigationReady) return;
      header.dataset.navigationReady = 'true';
      const shell = header.closest('.ip-sticky-header');
      if (shell) {
        const measure = () => document.documentElement.style.setProperty('--ip-sticky-header-height', Math.ceil(shell.getBoundingClientRect().height) + 'px');
        measure();
        new ResizeObserver(measure).observe(shell);
        const footer = document.querySelector('.ip-footer');
        if (footer) {
          const measureFooter = () => document.documentElement.style.setProperty('--ip-footer-height', Math.ceil(footer.getBoundingClientRect().height) + 'px');
          measureFooter();
          new ResizeObserver(measureFooter).observe(footer);
        }
      }
      const toggle = header.querySelector('[data-ip-nav-toggle]');
      const nav = header.querySelector('.ip-main-nav');
      const shop = header.querySelector('[data-ip-shop-menu]');
      const summary = shop.querySelector('summary');
      const mobile = matchMedia('(max-width:700px)');
      function setNavigation(open) {
        nav.dataset.open = String(open);
        toggle.setAttribute('aria-expanded', String(open));
        if (!open) shop.open = false;
      }
      toggle.addEventListener('click', () => setNavigation(nav.dataset.open !== 'true'));
      header.querySelectorAll('[data-shop-group-toggle]').forEach(button => {
        button.addEventListener('click', () => {
          const open = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(open));
          button.querySelector('span').textContent = open ? '−' : '+';
          button.closest('[data-shop-group]').dataset.expanded = String(open);
        });
      });
      summary.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          shop.open = true;
          shop.querySelector('.ip-shop-panel a').focus();
        }
      });
      document.addEventListener('click', event => {
        if (!header.contains(event.target)) { shop.open = false; setNavigation(false); }
      });
      header.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        if (shop.open) { shop.open = false; summary.focus(); }
        else { setNavigation(false); toggle.focus(); }
      });
      nav.addEventListener('focusout', event => {
        if (!nav.contains(event.relatedTarget)) shop.open = false;
      });
      nav.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
        shop.open = false;
        setNavigation(false);
      }));
      mobile.addEventListener('change', () => { setNavigation(false); });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
